<br>

<!-- Modal PAGO -->
<div class="modal fade" id="MODALPAGO" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div id="modalito2" class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">ORDEN DE PAGO PARA EL GASTO [{{ COD_GASTO_PAGAR }}]</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
            </div>
            <div class="modal-body">
                <form>
                    <div class="form-group">
                        <label for="formGroupExampleInput">COD_GASTOS:</label>
                        <input type="text" class="form-control" name="codgasto" id="codgasto" value="{{COD_GASTO_PAGAR}}" readonly="readonly">
                    </div>
                    <div class="form-group">
                        <label for="formGroupExampleInput2">FECHA PAGO:</label>
                        <input type="text" class="form-control" name="fec_edit" id="fec_edit" value="{{FECHA_CARGA_PAGAR | date:'dd-MM-yyyy'}}" readonly="readonly">
                    </div>

                    <div class="form-group">
                        <label for="formGroupExampleInput3">SUMA:</label>
                        <input type="text" class="form-control" name="importe" id="importe" value="{{TOTAL_PAGAR | currency:'$'}}" readonly="readonly">
                    </div>

                    <div class="form-group">
                        <label for="formGroupExampleInput4">ORDEN PAGO NRO: (ultima fué: <b>{{ ultimoPago }}</b>)</label>
                        <input type="text" class="form-control" [(ngModel)]="COD_PAGO" name="COD_PAGO" id="COD_PAGO" placeholder="ingresar manualmente del viejo sistema..">
                        <br>
                        <div *ngIf="errorpago==true" class="alert alert-danger" role="alert">
                            <h4 class="alert-heading">Error #OP001</h4>
                            <p>Se ingresó un número de Orden de Pago que se utilizó para otro destino..</p>
                            <p class="mb-0"></p>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="formGroupExampleInput4">COD_OPERACION:</label>
                        <input type="text" class="form-control" [(ngModel)]="COD_CHEQUE" name="COD_CHEQUE" id="COD_CHEQUE" placeholder="Ingresar manualmente del viejo sistema..">
                    </div>

                    <div class="form-group">
                        <label for="inputbanco">COD_BANCO:</label>
                        <select placeholder="Seleccione.." [(ngModel)]="COD_BANCO" name="COD_BANCO" id="COD_BANCO" class="form-control">
                            <option value="111400">111-400 "BANCO NACION CTA. CTE."</option>
                            <option value="111401" >111-401 "BANCO NACION TRANSFERENCIA"</option>
                            <option value="111402" >111-402 "BANCO ITAU TRANSFERENCIA"</option>
                            <option value="111403" >111-403 "BANCO ITAU CTA. CTE."</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label for="inputconcepto">COD_CONCEPTO:</label>
                        <input type="text" class="form-control" [(ngModel)]="COD_CONCEPTO" name="COD_CONCEPTO" id="COD_CONCEPTO" placeholder="no es necesario.. dejar vacio..">
                    </div>

                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Volver</button>
                <a *ngIf="error==false && errorpago==false" data-dismiss="modal" (click)="pagarGasto(); llamarNuevaTab();" type="button" class="btn btn-success">FINALIZAR PAGO</a>
                <a hidden id="botonNewTab" type="button" target="_blank" routerLink="/print" class="btn btn-success btn-block" mat-button>boton simula</a>
            </div>
        </div>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="modalfoto" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">Modal title</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
                ...
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary">Save changes</button>
            </div>
        </div>
    </div>
</div>

<!-- MODAL GET IMAGEN-->
<div class="modal fade" id="MODALIMAGEN" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div style="margin-top: 90px;" class="modal-dialog modal-lg" role="document">
        <div id="modalito" class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">IMAGEN TICKET / FACTURA</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
            </div>
            <div class="modal-body">
                <div style="text-align: center;">
                    <app-loading class="m-5" *ngIf="loading"></app-loading>
                    <img id="ima" *ngIf="!loading" style="width:300px; height:200px" src="{{ imgObtenida }}">
                </div>
            </div>

            <div class="modal-footer">
                <i id="botonrota" (click)="fullscreen()" class="material-icons">
                    settings_overscan
                </i> &nbsp;
                <i id="botonrota" (click)="rotate()" class="material-icons">
                    repeat
                </i> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Volver</button>
            </div>
        </div>
    </div>
</div>


<!-- aca empieza el formulario -->

<div class="animated fadeIn" id="todo">
    <div class="col-lg-12">

        <app-loading class="m-5" *ngIf="loading"></app-loading>

        <h5>
            Gasto COD: [{{ COD_GASTO_PAGAR }}]
        </h5>
        <p style="font-weight: bold;">"{{ DETALLE_PAGAR }}"</p>
        <p>[{{dataSource.data.length}} sub] -- Total: {{ TOTAL_PAGAR | currency:"$" }}</p>
        <p>estado: {{estgas}}</p>
        <hr>

        <!-- Button trigger modal 2 
        <button *ngIf="codi_detalle_edit" type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModal2">
            ver
        </button>
        -->
        <div id="grid" #TABLE>
            <mat-form-field>
                <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filtrar..">
            </mat-form-field>

            <div class="example-container mat-elevation-z8">
                <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
                    <!--- Note that these columns can be defined in any order.
                The actual rendered columns are set as a property on the row definition" -->
                    <!-- Checkbox Column -->
                    <ng-container matColumnDef="select">
                        <th mat-header-cell *matHeaderCellDef>
                            <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()" [indeterminate]="selection.hasValue() && !isAllSelected()">
                            </mat-checkbox>
                        </th>
                        <td mat-cell *matCellDef="let row">
                            <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)">
                            </mat-checkbox>
                        </td>
                    </ng-container>

                    <!-- Position Column -->
                    <ng-container matColumnDef="position">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> No. </th>
                        <td mat-cell *matCellDef="let element"> {{element.position}} </td>
                    </ng-container>

                    <ng-container matColumnDef="COD_GASTO">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> COD_GASTO </th>
                        <td mat-cell *matCellDef="let element"> {{element.COD_GASTO}} </td>
                    </ng-container>

                    <ng-container matColumnDef="COD_DETALLE">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> COD_DETALLE </th>
                        <td mat-cell *matCellDef="let element"> {{element.COD_DETALLE}} </td>
                    </ng-container>
                    <!--
                    <ng-container matColumnDef="COD_DETALLE">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> COD_DETALLE </th>
                        <td mat-cell *matCellDef="let element"> {{element.COD_DETALLE}} </td>
                    </ng-container>
                    <ng-container matColumnDef="FECHA_CARGA">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> FECHA_CARGA </th>
                        <td mat-cell *matCellDef="let element"> {{element.FECHA_CARGA | date:"dd/MM/yy"}} </td>
                    </ng-container>
                    -->
                    <ng-container matColumnDef="FECHA_TICKET">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> FECHA_TICKET </th>
                        <td mat-cell *matCellDef="let element"> {{element.FECHA_TICKET | date:"dd/MM/yy"}} </td>
                    </ng-container>
                    <ng-container matColumnDef="DETALLE">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> DETALLE </th>
                        <td style="font-style: italic; font-weight: bold;" mat-cell *matCellDef="let element">"{{(element.DETALLE !=='null') ? (element.DETALLE) : ('----')}}"</td>
                        <!-- <td style="font-style: italic; font-weight: bold;" mat-cell *matCellDef="let element">"{{ (element.DETALLE===null) ? ('null') : "---" }}"</td> -->
                    </ng-container>
                    <ng-container matColumnDef="IMPORTE">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> IMPORTE </th>
                        <td style="font-weight: bold;" mat-cell *matCellDef="let element"> {{element.IMPORTE | currency:"$" }} </td>
                    </ng-container>
                    <ng-container matColumnDef="CATEGORIA">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> CATEGORIA </th>
                        <td mat-cell *matCellDef="let element"> {{ element.CATEGORIA }} </td>
                    </ng-container>
                    <ng-container matColumnDef="IMAGEN">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> IMAGEN </th>
                        <td mat-cell *matCellDef="let element">
                            <a type="button" class="btn btn-lg btn-info" data-toggle="popover" title="Click derecho, guardar imagen (descargar)" data-content="FOTO">+</a>
                        </td>
                    </ng-container>
                    <!--
                    <ng-container matColumnDef="OBSERVACIONES">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> OBSERVACIONES </th>
                        <td mat-cell *matCellDef="let element"> {{ element.OBSERVACIONES }} </td>
                    </ng-container>
                    -->
                    <!--
                    <ng-container matColumnDef="IMAGEN">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> IMAGEN </th>
                        <td mat-cell *matCellDef="let element"> <img style="width: 50px; height: 50px;" src="{{element.IMAGEN}}"></td>
                    </ng-container>
                  -->
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

                    <tr mat-row (click)="selectRow(row.COD_DETALLE)" data-toggle="modal" data-target="#MODALIMAGEN" *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row);"></tr>
                </table>
            </div>

            <mat-paginator [pageSize]=50 [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>

            <a type="button" target="_blank" routerLink="/print-gastos" class="btn btn-success btn-block" mat-button (click)="imprimirGastos()">IMPRIMIR GASTO {{ COD_GASTO_PAGAR }}</a>
            <!-- Button trigger modal -->
            <button hidden *ngIf="estgas=='AUTORIZADO'" (click)="getUltimoNroPago()" type="button" class="btn btn-success btn-block" data-toggle="modal" data-target="#MODALPAGO">
                  EMITIR PAGO!
            </button>
            <button class="btn-block" color="dark" mat-button (click)="exportAsExcel()" [disabled]="dataSource.data.length==0">Exportar a Excel</button>
        </div>
        <hr>

        <button type="button" class="btn btn-secondary btn-block" mat-button (click)="volver()" routerLink="/vergastos-jorge">Volver</button>
    </div>


</div>